const SALESFORCE_HOST_SUFFIXES = ['salesforce.com', 'lightning.force.com'];

/**
 * True when the bundle is running inside Salesforce (LWC / Lightning), not on
 * a Zuora host. Scratch orgs, sandboxes and production all live under these
 * suffixes — `*.scratch.my.salesforce.com`, `*.lightning.force.com`, etc.
 *
 * Those mounts only want the AI agent. They have no Billing identity or
 * `/v1/navigation`, so treating them as a normal nav page leaves chrome
 * (the Global Nav loading skeleton) up forever.
 */
export const isSalesforceHost = (
  hostname = typeof window !== 'undefined' ? window.location.hostname : '',
): boolean =>
  SALESFORCE_HOST_SUFFIXES.some(
    (suffix) => hostname === suffix || hostname.endsWith(`.${suffix}`),
  );
